import Invoice from '@/services/invoice'
import Report from '@/services/report'

const fetchInvoicesTotal = async ({ commit }) => {
  return new Promise((resolve, reject) => {
    Invoice.totalAvailable().then((response) => {
      commit('SET_INVOICES_TOTAL', response.data)
      resolve(response.data)
    }).catch((error) => {
      reject(error)
    })
  })
}

const fetchInvoicesSelected = async ({ commit }, payload = { invoice_ids: [] }) => {
  return new Promise((resolve, reject) => {
    Invoice.selectedAvailable(payload).then((response) => {
      commit('SET_INVOICES_SELECTED', response.data)
      resolve(response.data)
    }).catch((error) => {
      commit('SET_INVOICES_SELECTED', error.response.data)
      reject(error)
    })
  })
}

const fetchSimulateInvoices = async ({ commit }, payload = { invoice_ids: [] }) => {
  return new Promise((resolve, reject) => {
    Invoice.simulate(payload).then((response) => {
      resolve(response.data)
    }).catch((error) => {
      reject(error)
    })
  })
}

const fetchTaxCommission = async ({ commit }) => {
  return new Promise((resolve, reject) => {
    Invoice.taxCommission().then((response) => {
      commit('SET_TAX_COMMISSION', response.data)
      resolve(response.data)
    }).catch((error) => {
      reject(error)
    })
  })
}

const getInvoicesAvailable = async (context, page) => {
  return new Promise((resolve, reject) => {
    Invoice.available(page).then((response) => {
      resolve(response.data)
    }).catch((error) => {
      reject(error)
    })
  })
}

const filterInvoices = async (context, filter) => {
  return new Promise((resolve, reject) => {
    Invoice.filterAvailable(filter).then((response) => {
      resolve(response.data)
    }).catch((error) => {
      reject(error)
    })
  })
}

const downloadReport = async (context, jobId) => {
  return new Promise((resolve, reject) => {
    Report.download(jobId).then((response) => {
      resolve(response.data)
    }).catch((error) => {
      reject(error)
    })
  })
}

const removeInvoiceSelected = ({ commit }, payload) => {
  commit('REMOVE_INVOICE_SELECTED', payload)
}

const resetInvoicesSelected = ({ commit }) => {
  commit('RESET_INVOICES')
}

export default {
  fetchInvoicesTotal,
  fetchInvoicesSelected,
  fetchTaxCommission,
  getInvoicesAvailable,
  filterInvoices,
  removeInvoiceSelected,
  resetInvoicesSelected,
  fetchSimulateInvoices,
  downloadReport
}



// WEBPACK FOOTER //
// ./src/features/invoices/store/actions.js